import { Fragment } from 'react';
import styled from '@emotion/styled';
import H6 from '@base/H6/H6';
import BaseTags from '@base/Tags/Tags';
import { Spacings } from '@styles/index';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 85px;
  margin-top: ${Spacings.SPACING_9B};
`;

const StyledH6 = styled(H6)`
  color: var(--color-i-gray);
  display: flex;
  align-items: center;
`;

const Tags = () => {
  return (
    <Wrapper>
      <Fragment key="free-tag">
        <BaseTags type="filled" bgColor="var(--color-text-secondary)">
          Free
        </BaseTags>
        <StyledH6>Test</StyledH6>
      </Fragment>
    </Wrapper>
  );
};

export default Tags;
